import { combineReducers } from 'redux';
import formReducer from './form';

const onboardingReducer = combineReducers({
  form: formReducer,
});

export default onboardingReducer;
